import { Block, Close, RocketLaunchRounded, Public, Lock, CopyAll, HelpRounded } from '@mui/icons-material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import {
    Alert,
    AlertTitle,
    Box,
    Card,
    Checkbox,
    Chip,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    FormControlLabel,
    IconButton,
    List,
    ListItem,
    ListItemSecondaryAction,
    ListItemText,
    Paper,
    Switch,
    Tab,
    Typography,
} from '@mui/material';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useConfirm } from 'material-ui-confirm';
import React, { useEffect, useState, useRef } from 'react';
import { IMaskInput } from 'react-imask';
import { Link, useNavigate, useParams } from 'react-router-dom';
import useDialog from '../../../../hooks/useDialog';
import useErrors from '../../../../hooks/useErrors';
import { useFetch } from '../../../../hooks/useFecth';
import server from '../../../../services/server';
import { useClub } from '../../../Club/ClubContext';
import { useHelper } from '../../../../context/HelpSidebarContext';
import ClubTabLayout from './ClubTabLayout';

const PriceField = React.forwardRef(function PriceField(props, ref) {
    const { onChange, value, type, ...other } = props;
    return (
        <IMaskInput
            {...other}
            value={String(value)}
            inputRef={ref}
            onAccept={value => onChange(props.name, value)}
            mask={'R$ num'}
            unmask={true}
            blocks={{
                num: {
                    mask: Number,
                    scale: 2,
                    thousandsSeparator: '.',
                    radix: ',',
                },
            }}
        />
    );
});

function ListProductsKit({ selected = [], setFieldValue, showSummary = false , data }) {
    // const { data, error } = useFetch(`club`);

    // if (error) return null;

    function handleSelect(id) {
        if (selected.includes(id)) {
            const newlist = selected.filter(i => i !== id);
            setFieldValue('product_kit', newlist);
        } else {
            setFieldValue('product_kit', [...selected, id]);
        }
    }

    return (
        <>
            {Boolean(data) && Array.isArray(data?.resale_products) ? (
                <Paper variant="outlined">
                    <List dense>
                        <>
                            {data?.resale_products?.map(item => (
                                <React.Fragment key={item?.id}>
                                    <ListItem divider>
                                        <ListItemText
                                            primary={item?.name}
                                            secondary={
                                                <Typography variant="body2" color="primary" fontWeight="bold">
                                                    R$ {Number(item?.price || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                                                </Typography>
                                            }
                                        />
                                        <ListItemSecondaryAction>
                                            <Checkbox onChange={(e, v) => handleSelect(item?.id)} checked={selected.includes(item?.id)} />
                                        </ListItemSecondaryAction>
                                    </ListItem>
                                </React.Fragment>
                            ))}
                        </>
                    </List>
                </Paper>
            ) : (
                <Alert severity="warning">Nenhum benefício encontrado</Alert>
            )}
        </>
    );
}

// Componente de ajuda sobre planos do clube
const HelpContent = () => (
    <Stack spacing={2}>
        <Typography variant="title-md">Planos do Clube</Typography>

        <Typography variant="body1">
            Planos do clube são uma forma de monetizar seu clube de benefícios. Você pode criar planos com diferentes benefícios e preços.
        </Typography>
        <Typography variant="body1">O clube de descontos e cashback já está em todos os planos que você criar. Ele é a base do seu plano.</Typography>

        <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
            Campos do Plano:
        </Typography>

        <Stack spacing={1}>
            <Typography variant="body2">
                • <strong>Nome:</strong> Adicione o nome do plano
            </Typography>
            <Typography variant="body2">
                • <strong>SKU:</strong> Código único do plano (obrigatório para clubes que não vendem)
            </Typography>
            <Typography variant="body2">
                • <strong>Descrição:</strong> Adicione a descrição do plano
            </Typography>
            <Typography variant="body2">
                • <strong>Preço:</strong> Adicione o preço do plano (obrigatório para clubes revendedores)
            </Typography>
            <Typography variant="body2">
                • <strong>Benefícios:</strong> Selecione os produtos que farão parte do plano
            </Typography>
            <Typography variant="body2">
                • <strong>Visibilidade:</strong> Defina se o plano é público ou privado
            </Typography>
            <Typography variant="body2">
                • <strong>Status:</strong> Ative ou desative o plano
            </Typography>
        </Stack>

        <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
            Detalhes dos Campos:
        </Typography>

        <Stack spacing={1}>
            <Typography variant="body2">
                <strong>SKU:</strong> Código único de identificação do plano. Deve conter apenas letras maiúsculas, números, hífen e underscore. Exemplo: PLANO_BASICO_001
            </Typography>
            <Typography variant="body2">
                <strong>Preço:</strong> Valor de venda do plano. Obrigatório apenas para clubes revendedores (que comercializam planos).
            </Typography>
            <Typography variant="body2">
                <strong>Benefícios:</strong> Campo de seleção múltipla de produtos do clube. Você pode selecionar vários produtos para o plano.
            </Typography>
            <Typography variant="body2">
                <strong>Visibilidade:</strong>
            </Typography>
            <Stack spacing={0.5} sx={{ ml: 2 }}>
                <Typography variant="body2">
                    • <strong>Público:</strong> Visível na página de vendas para todos
                </Typography>
                <Typography variant="body2">
                    • <strong>Privado:</strong> Apenas com link de adesão específico
                </Typography>
            </Stack>
            <Typography variant="body2">
                <strong>Status:</strong> Controle se o plano está ativo (disponível para venda) ou inativo.
            </Typography>
        </Stack>

        <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
            Fluxo de Criação:
        </Typography>

        <Stack spacing={1}>
            <Typography variant="body2">
                1. <strong>Etapa 1:</strong> Selecione os benefícios do plano
            </Typography>
            <Typography variant="body2">
                2. <strong>Etapa 2:</strong> Defina nome, descrição, preço e visibilidade
            </Typography>
            <Typography variant="body2">
                3. <strong>Salvar:</strong> O plano será criado e ficará disponível
            </Typography>
        </Stack>
    </Stack>
);

function DialogContainer({ mutate , clubData }) {
    // const { club: clubData } = useClub();
    const { id, open, handleClose } = useDialog('#planos');
    const [tab, setTab] = useState('#produtos'); // Começar com produtos
    const [step, setStep] = useState('products'); // 'products' ou 'details'
    const navigation = useNavigate();
    const { setErrors, enqueueSnackbar } = useErrors();
    const confirm = useConfirm();
    const { chargeHelp } = useHelper();
    const { data } = useFetch(id ? `clubs/${clubData?.id}/plans/${id}` : null);
    // const helpOpenedRef = useRef(false);

    console.log('data - WESLEY ****  ', data)


    const hasBenefits = clubData?.functions?.includes('benefit');
    const isReseller = clubData?.functions?.includes('reseller');

    // Auto-abrir ajuda quando onboarding estiver ativo e dialog abrir (apenas uma vez)
    // useEffect(() => {
    //     if (open && !helpOpenedRef.current) {
    //         const onboardingStatus = localStorage.getItem('onboarding_completed');
    //         if (onboardingStatus !== 'true') {
    //             // Abrir help automaticamente
    //             setTimeout(() => {
    //                 chargeHelp(<HelpContent />);
    //                 helpOpenedRef.current = true; // Marcar que já abriu
    //             }, 500); // Pequeno delay para melhor UX
    //         }
    //     }
        
    //     // Resetar quando dialog fechar
    //     if (!open) {
    //         helpOpenedRef.current = false;
    //     }
    // }, [open, chargeHelp]);

    // Schema de validação
    const validationSchema = Yup.object({
        name: Yup.string()
            .required('Nome do plano é obrigatório')
            .min(2, 'Nome deve ter pelo menos 2 caracteres'),
        sku: Yup.string()
            .required('SKU do plano é obrigatório')
            .min(3, 'SKU deve ter pelo menos 3 caracteres')
            .matches(/^[A-Z0-9_-]+$/, 'SKU deve conter apenas letras maiúsculas, números, hífen e underscore')
            .max(50, 'SKU deve ter no máximo 50 caracteres'),
        description: Yup.string()
            .required('Descrição do plano é obrigatória')
            .min(10, 'Descrição deve ter pelo menos 10 caracteres'),
        // price: Yup.number()
        //     .min(0, 'Preço deve ser maior ou igual a zero')
        //     .when([], {
        //         is: () => isReseller,
        //         then: (schema) => schema.required('Preço é obrigatório para clubes revendedores'),
        //         otherwise: (schema) => schema.notRequired(),
        //     }),
    });

    const { values, handleSubmit, handleChange, setFieldValue, setValues, isSubmitting, resetForm, isValid, handleReset, errors, touched } = useFormik({
        initialValues: {
            name: '',
            description: '',
            type: 'plan',
            price: 0,
            disccount: '',
            image: '',
            sku: '',
            product_kit: [],
            status: '',
            visibility: 'PUBLIC', // 'PUBLIC' ou 'PRIVATE'
            action: 'create',
            step: 'products',
        },
        validationSchema,
        onSubmit: async (values, { setSubmitting, resetForm }) => {
            try {
                // Validar se o preço de venda não é menor que o custo total
                // const currentTotalCost = calculateTotalCost(values.product_kit);
                // if (Number(values.price) < currentTotalCost && values.product_kit.length > 0) {
                //     enqueueSnackbar(`O preço de venda não pode ser menor que o custo total dos benefícios (R$ ${currentTotalCost.toLocaleString('pt-BR', { minimumFractionDigits: 2 })})`, { variant: 'error' });
                //     return;
                // }

                if (!Boolean(values.id)) {
                    setSubmitting(true);
                    const { data } = await server.post(`clubs/${clubData?.id}/plans`, { ...values, price: Number(values.price) });
                    // navigation(`#planos|${data?.data?.id}`, { replace: true });
                    enqueueSnackbar(`Plano adicionado`);
                    handleClose();

                }

                if (Boolean(values.id)) {
                    if (values.action === 'delete') {
                        setSubmitting(true);
                        await server.delete(`clubs/${clubData?.id}/plans/${values.id}`, values);
                        enqueueSnackbar(`Plano removido`);
                    } else {
                        setSubmitting(true);
                        await server.put(`clubs/${clubData?.id}/plans/${values.id}`, { ...values, price: Number(values.price) });
                        enqueueSnackbar(`Plano alterado`);
                    }

                    resetForm();
                    handleClose();
                }

                await mutate();
                setSubmitting(false);
            } catch (error) {
                setSubmitting(false);
                setErrors(error);
            }
        },
    });

    const checkoutUrl = `${clubData?.domain}/planos/${values?.id}`;
    
    // Função para calcular o custo total dos produtos selecionados
    const calculateTotalCost = selectedProductIds => {
        if (!clubData?.resale_products || !selectedProductIds?.length) return 0;
        const selectedProducts = clubData.resale_products.filter(item => selectedProductIds.includes(item?.id));
        return selectedProducts.reduce((sum, item) => sum + Number(item?.price || 0), 0);
    };

    const totalCost = calculateTotalCost(values.product_kit);

    const handleDelete = async () => {
        try {
            // Exibe o diálogo de confirmação
            await confirm({
                title: 'Remover plano?',
                description: 'Essa ação é permanente. Você confirma a remoção?',
            });

            // Se confirmado, executa as ações
            setFieldValue('action', 'delete');
            handleSubmit();
        } catch (error) {
            setErrors(error);
        }
    };

    useEffect(() => {
        if (data) {
            setValues({ ...data, product_kit: data?.Kit.map(i => i.resaleId), action: 'update' }, true);
            // setValues({ ...data, product_kit: data?.resale_products?.map(i => i.id), action: 'update' }, true);
            // Se está editando, vai direto para os dados
            setStep('details');
            setTab('#dados');
        }
        return () => {
            handleReset();
        };
    }, [data, setValues]);

    console.log('product_kit - WESLEY ****  ',  clubData?.resale_products?.map(i => i.id))


    // console.log('hasBenefits - WESLEY ****  ', hasBenefits)
    // console.log('isReseller - WESLEY ****  ', isReseller)
    // console.log('clubData - WESLEY ****  ', clubData)
    console.log('data - WESLEY ****  ', data)
    // console.log('values - WESLEY ****  ', values) 

    // Função para avançar para a próxima etapa
    const handleNextStep = () => {
        // if (values.product_kit.length === 0) {
        //     enqueueSnackbar('Selecione pelo menos um produto para continuar', { variant: 'warning' });
        //     return;
        // }
        setStep('details');
        setTab('#dados');
    };

    // Função para voltar para a etapa anterior
    const handlePrevStep = () => {
        setStep('products');
        setTab('#produtos');
    };

    

    const renderPlanDetails = () => {
        return (
            <>
                <Stack gap={2}>
                    <TextField 
                        onChange={handleChange} 
                        label={`Nome do plano`} 
                        value={values.name} 
                        name="name"
                        error={touched.name && Boolean(errors.name)}
                        helperText={touched.name && errors.name}
                        required
                    />

                    <TextField 
                        onChange={handleChange} 
                        label={`SKU do plano`} 
                        value={values.sku} 
                        name="sku"
                        placeholder="Ex: PLANO_BASICO_001"
                        error={touched.sku && Boolean(errors.sku)}
                        helperText={touched.sku && errors.sku || "Código único do plano para identificação no sistema"}
                        required
                    />

                    <TextField
                        onChange={handleChange}
                        multiline
                        rows={4}
                        maxRows={10}
                        label={`Descrição do plano`}
                        value={values.description}
                        name="description"
                        error={touched.description && Boolean(errors.description)}
                        helperText={touched.description && errors.description}
                        required
                    />
                    {isReseller && (
                        <>
                            <TextField
                                onChange={setFieldValue}
                                label="Preço de venda"
                                value={values.price}
                                name="price"
                                type="number"
                                error={touched.price && Boolean(errors.price)}
                                helperText={touched.price && errors.price}
                                required={isReseller}
                                // error={Number(values.price) < totalCost && values.product_kit.length > 0}
                                // helperText={
                                //     Number(values.price) < totalCost && values.product_kit.length > 0
                                //         ? `O preço de venda não pode ser menor que o custo total (R$ ${totalCost.toLocaleString('pt-BR', { minimumFractionDigits: 2 })})`
                                //         : ''
                                // }
                                InputProps={{
                                    inputComponent: PriceField,
                                }}
                                InputLabelProps={{
                                    shrink: true / false,
                                }}
                            />

                            {/* Visibilidade do plano PUBLIC ou PRIVATE */}
                            <Box sx={{ mb: 2 }}>
                                <Typography variant="subtitle2" gutterBottom>
                                    Visibilidade do plano
                                </Typography>
                                <Stack direction="row" spacing={2}>
                                    <Card
                                        onClick={() => setFieldValue('visibility', 'PUBLIC')}
                                        sx={{
                                            flex: 1,
                                            cursor: 'pointer',
                                            borderColor: values?.visibility === 'PUBLIC' ? 'primary.main' : 'grey.300',
                                            boxShadow: values?.visibility === 'PUBLIC' ? 3 : 0,
                                            textAlign: 'center',
                                            p: 2,
                                            transition: 'box-shadow 0.2s, border-color 0.2s',
                                        }}
                                    >
                                        <Stack alignItems="center" spacing={1}>
                                            <Public
                                                sx={{
                                                    fontSize: 36,
                                                    color: values?.visibility === 'PUBLIC' ? '#1976d2' : '#757575',
                                                }}
                                            />
                                            <Typography
                                                variant="subtitle1"
                                                fontWeight="bold"
                                                color={values?.visibility === 'PUBLIC' ? 'primary' : 'text.secondary'}
                                            >
                                                Público
                                            </Typography>
                                            <Typography variant="caption" color="text.secondary">
                                                Visível na página de vendas
                                            </Typography>
                                        </Stack>
                                    </Card>
                                    <Card
                                        onClick={() => setFieldValue('visibility', 'PRIVATE')}
                                        sx={{
                                            flex: 1,
                                            cursor: 'pointer',
                                            borderColor: values?.visibility === 'PRIVATE' ? 'primary.main' : 'grey.300',
                                            boxShadow: values?.visibility === 'PRIVATE' ? 3 : 0,
                                            textAlign: 'center',
                                            p: 2,
                                            transition: 'box-shadow 0.2s, border-color 0.2s',
                                        }}
                                    >
                                        <Stack alignItems="center" spacing={1}>
                                            <Lock
                                                sx={{
                                                    fontSize: 36,
                                                    color: values?.visibility === 'PRIVATE' ? '#1976d2' : '#757575',
                                                }}
                                            />
                                            <Typography
                                                variant="subtitle1"
                                                fontWeight="bold"
                                                color={values?.visibility === 'PRIVATE' ? 'primary' : 'text.secondary'}
                                            >
                                                Privado
                                            </Typography>
                                            <Typography variant="caption" color="text.secondary">
                                                Apenas com link de adesão
                                            </Typography>
                                        </Stack>
                                    </Card>
                                </Stack>
                            </Box>
                            {values.id && (
                                <TextField
                                    label={`Link de venda`}
                                    value={checkoutUrl}
                                    aria-readonly
                                    inputProps={{ readOnly: true }}
                                    InputProps={{
                                        endAdornment: (
                                            <IconButton
                                                onClick={() => {
                                                    navigator.clipboard.writeText(checkoutUrl);
                                                    enqueueSnackbar('Link copiado para área de transferência', {
                                                        variant: 'success',
                                                    });
                                                }}
                                            >
                                                <CopyAll />
                                            </IconButton>
                                        ),
                                    }}
                                />
                            )}
                        </>
                    )}
                    {values.id && (
                        <FormControlLabel
                            control={<Switch checked={values.status} onChange={e => setFieldValue('status', e.target.checked)} />}
                            orientation="horizontal"
                            label="Status ativo"
                        />
                    )}
                </Stack>
            </>
        );
    };

    return (
        <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
            <Stack direction="row" justifyContent="space-between" alignItems="center">
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <DialogTitle>Adicionando/editando planos</DialogTitle>
                </Box>
                <Box>
                    <IconButton
                        onClick={() => {
                            chargeHelp(<HelpContent />);
                        }}
                    >
                        <HelpRounded />
                    </IconButton>
                    <IconButton onClick={handleClose} aria-label="close" sx={{ marginRight: 2 }}>
                        <Close />
                    </IconButton>
                </Box>
            </Stack>
            <Divider />
            <TabContext value={tab}>
                <TabList onChange={(e, tab) => setTab(tab)}>
                    {hasBenefits && <Tab value="#produtos" label="Produtos do plano" />}
                    <Tab value="#dados" label="Dados do plano" />
                </TabList>
                <Divider />
                <DialogContent dividers>
                    {/* Se o clube tem gestão de beneficios ativa, mostra a tab de produtos */}
                    {hasBenefits && (
                        <>
                            {/* Etapa de seleção de produtos (apenas para novos planos) */}

                            <TabPanel sx={{ p: 0 }} value="#produtos">
                                <Alert severity="info" sx={{ mb: 2 }}>
                                    <AlertTitle fontWeight="bold">Etapa 1 de 2: Seleção os benefícios do plano</AlertTitle>

                                    <Typography variant="body2" color="text.secondary">
                                        Os benefícios farão parte do plano. Você poderá definir o nome, descrição e preço na próxima etapa.
                                    </Typography>
                                </Alert>
                                <ListProductsKit data={clubData} selected={values?.product_kit} setFieldValue={setFieldValue} showSummary={true} />
                            </TabPanel>

                            {/* Etapa de dados do plano */}

                            <TabPanel sx={{ p: 0 }} value="#dados">
                                <Alert severity="info" sx={{ mb: 2 }}>
                                    <AlertTitle fontWeight="bold">Etapa 2 de 2: Defina os detalhes do plano</AlertTitle>

                                    <Typography variant="body2" color="text.secondary">
                                        Agora você define nome, descrição e se você comercializa o preço do plano.
                                    </Typography>
                                </Alert>

                                {renderPlanDetails()}
                            </TabPanel>

                            {/* Tab de produtos adicionais (apenas para edição) */}
                            {/* {values.id && (
                                <TabPanel value="#adicionais" sx={{ p: 0 }}>
                                    <ListProductsKit selected={values?.product_kit} setFieldValue={setFieldValue} showSummary={true} />
                                </TabPanel>
                            )} */}
                        </>
                    )}
                    {!hasBenefits && <>{renderPlanDetails()}</>}
                </DialogContent>
                {hasBenefits && (
                    <>
                        <Paper sx={{ p: 2, m: 2, bgcolor: 'primary.light', color: 'primary.contrastText' }}>
                            <Stack direction="row" justifyContent="space-between" alignItems="center">
                                <Typography variant="h6">Total de custo:</Typography>
                                <Typography variant="h6" fontWeight="bold">
                                    R$ {totalCost.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                                </Typography>
                            </Stack>
                            <Typography variant="body2" sx={{ mt: 1 }}>
                                {values.product_kit?.length} benefícios(s) selecionado(s)
                            </Typography>
                        </Paper>
                        <Divider />
                    </>
                )}
            </TabContext>
            <DialogActions>
                {!!values.id && (
                    <Button color="error" variant="outlined" onClick={handleDelete}>
                        Excluir
                    </Button>
                )}

                {/* Botões para novos planos */}
                {!values.id && tab === '#produtos' && (
                    <Button variant="contained" onClick={handleNextStep}>
                        Continuar
                    </Button>
                )}

                {!values.id && tab === '#dados' && (
                    <Button variant="contained" type="submit" onClick={handleSubmit} disabled={!isValid || isSubmitting}>
                        Salvar
                    </Button>
                )}

                {/* Botão para edição */}
                {values.id && (
                    <Button variant="contained" type="submit" onClick={handleSubmit} disabled={!isValid || isSubmitting}>
                        Salvar
                    </Button>
                )}
            </DialogActions>
        </Dialog>
    );
}

// function DialogContainer({ mutate }) {

//     return <Form mutate={mutate} />;
// }

const visibility = {
    PUBLIC: 'Público',
    PRIVATE: 'Privado',
    CUSTOM: 'Customizado',
};
export default function ProductsClub({ club }) {
    const { id } = useParams();
    const { data, mutate } = useFetch(`clubs/${id}/plans`);

    return (
        <>
            <ClubTabLayout
                actions={
                    <Button component={Link} to="#planos" variant="outlined">
                        Adicionar plano
                    </Button>
                }
            >
                    <List>
                        {/* {!!data && !Boolean(data?.length) && (
                            <Paper sx={{ border: 0, p: 4 }}>
                                <Stack alignItems="center" justifyContent="center" gap={1}>
                                    <RocketLaunchRounded sx={{ fontSize: 40 }} />
                                    <Typography variant="body1">Comece agora!</Typography>
                                    <Button component={Link} to="#planos" variant="outlined">
                                        Criar plano
                                    </Button>
                                </Stack>
                            </Paper>
                        )} */}
                        {data?.map(item => (
                            <React.Fragment key={item.id}>
                                <ListItem
                                    secondaryAction={
                                        <IconButton component={Link} to={`#planos|${item.id}`}>
                                            <ChevronRightIcon />
                                        </IconButton>
                                    }
                                >
                                    <ListItemText primary={item.name} secondary={<Chip size="small" label={visibility[item.visibility]} />} />
                                </ListItem>
                                <Divider />
                            </React.Fragment>
                        ))}
                    </List>
            </ClubTabLayout>
            <DialogContainer mutate={mutate} clubData={club} />
        </>
    );
}
